import { render, staticRenderFns } from "./Replay.vue?vue&type=template&id=060a7b70&scoped=true"
import script from "./Replay.vue?vue&type=script&lang=ts"
export * from "./Replay.vue?vue&type=script&lang=ts"
import style0 from "./Replay.vue?vue&type=style&index=0&id=060a7b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a7b70",
  null
  
)

export default component.exports